import { useContext, useRef, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import { validateFile } from "../../utils/application-helper";
import VideoPlayer from "../components/VideoPlayer";
import axiosHttp from "../config/axios.interceptor";
import axios from "axios";
import {
  base_url,
  dataURItoBlob,
  errorResponseMessage,
  httpHeaderConfig,
} from "./const.prop";
import Delete from "./Delete";
import { AuthContext } from "../contexts/AuthContext";

const PostVideo = ({ data = null }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [videoSrc, setVideoSrc] = useState(data ? data?.url : null);
  const [videoBlob, setVideoBlob] = useState(null);
  const [caption, setCaption] = useState(data ? data?.description : null);
  const [showButton, setShowButton] = useState(false);
  const videoWrapperStyle = { width: "100%", height: "300px" };
  const inputRef = useRef(null);
  const triggerFileSelectHandler = () => inputRef.current.click();
  const fileChangeHandler = () => {
    const file = inputRef.current.files[0];
    const validationRes = validateFile(file, "video");
    const fileReader = new FileReader();
    fileReader.onload = () => setVideoBlob(fileReader.result);
    fileReader.readAsDataURL(file);
    if (validationRes.errors.length) {
      appContext.updateNotificationState({
        type: "error",
        message: validationRes.errors[0],
        show: true,
      });
      return;
    }
    setVideoSrc(URL.createObjectURL(file));
  };
  const postSubmit = (savedResponse) => {
    if (savedResponse && savedResponse.status !== 200) {
      appContext.updateNotificationState({
        type: "error",
        message: errorResponseMessage(error),
        show: true,
      });
      appContext.updateLoaderState(false);
    }
    const savedUrl = savedResponse ? savedResponse.data.tempPath : data?.url;
    if (data?.id) {
      axiosHttp
        .post(`post-data/${data.id}`, {
          type: "video",
          text: caption,
          url: savedUrl,
        })
        .then((postResponse) => {
          if (postResponse.status === 201) {
            appContext.updateLoaderState(false);
            appContext.updateModalState();
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(error),
              type: "error",
            });
            authContext.logout();
          }
          if (error.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
            appContext.updateLoaderState(false);
            setShowButton(false);
            return;
          }
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(error),
            show: true,
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
        });
    } else {
      axiosHttp
        .post("post-data", {
          type: "video",
          text: caption,
          url: savedUrl,
        })
        .then((postResponse) => {
          if (postResponse.status === 201) {
            appContext.updateLoaderState(false);
            appContext.updateModalState();
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(error),
              type: "error",
            });
            authContext.logout();
          }
          if (error.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
            appContext.updateLoaderState(false);
            setShowButton(false);
            return;
          }
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(error),
            show: true,
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
        });
    }
  };
  const postHandler = () => {
    setShowButton(true);
    appContext.updateLoaderState(true);
    if (videoBlob === null) {
      postSubmit();
    }
    const formData = new FormData();
    formData.append("image", dataURItoBlob(videoBlob));
    axios
      .post(base_url + "upload-image", formData, {
        headers: {
          ...httpHeaderConfig,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((savedResponse) => postSubmit(savedResponse))
      .catch((error) => {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
          appContext.updateLoaderState(false);
          setShowButton(false);
          return;
        }
        appContext.updateNotificationState({
          type: "error",
          message: errorResponseMessage(error),
          show: true,
        });
        appContext.updateLoaderState(false);
        setShowButton(false);
      });
  };
  const reSetVideo = () => setVideoSrc(null);
  return (
    <>
      <div className="modal-body">
        {!videoSrc && (
          <div
            className="card frame cursor-pointer"
            onClick={triggerFileSelectHandler}
          ></div>
        )}
        {videoSrc && (
          <div className="modal-video-container video-wrapper">
            <Delete clickHandler={reSetVideo} />
            <VideoPlayer wrapper={videoWrapperStyle} videoSrc={videoSrc} />
          </div>
        )}
        <input
          type="text"
          className="form-control w-75 form-video mt-4"
          placeholder="Add a Caption...."
          onChange={(e) => setCaption(e.target.value)}
          value={caption}
        />
        <input
          onChange={fileChangeHandler}
          type="file"
          className="visible-hidden"
          ref={inputRef}
        />
      </div>
      <div className="modal-footer mt-2 mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={postHandler}
          disabled={!(caption && videoSrc) || appContext.loaderState}
          className="btn btn-outline-primary modal-btn"
        >
          Done
        </button>
      </div>
    </>
  );
};

export default PostVideo;
